import "./list.scss"
import Sidebar from "../../components/sidebar/Sidebar"
import Navbar from "../../components/navbar/Navbar"
import CorporateDetails from "../../components/patient-timeline/corporate-details"

const CorporateDetailsContainer = () => {
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <CorporateDetails />
      </div>
    </div>
  )
}

export default CorporateDetailsContainer